export default __webpack_public_path__ + "5fc905d4d33f3daf9098fa76ce1e7c6c.png";